module.exports = __webpack_public_path__ + "static/media/rectangular-blobs.21d9f440.svg";